import styles from './InvitedUserInsightsTour.module.css';

const InvitedUserInsightsTour = ({ onClose }) => {
    return (
        <>
            <div className={styles.modal}></div>
            <div className={styles.container}>
                <div className={styles.content}>
                    <h2>Welcome to Advisor Insight!</h2>
                    <p>Advisor Insight helps you improve your advisory practice by benchmarking you against other advisors and emailing you grades and recommendations.</p>
                    <p>Explore our Insights section to take other surveys and instantly see how you compare to peers.</p>
                    <p>Click <strong>About Us</strong> to learn more about Advisor Insight.</p>
                </div>
                <div className={styles.buttonContainer}>
                    <button className={styles.closeButton} onClick={onClose}>Got it</button>
                </div>
                <button className="close" onClick={onClose}></button>
            </div>
        </>
    );
};

export default InvitedUserInsightsTour;